import { render, staticRenderFns } from "./VitalSignsForm.vue?vue&type=template&id=1f1f4901&scoped=true"
import script from "./VitalSignsForm.vue?vue&type=script&lang=js"
export * from "./VitalSignsForm.vue?vue&type=script&lang=js"
import style0 from "./VitalSignsForm.vue?vue&type=style&index=0&id=1f1f4901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f4901",
  null
  
)

export default component.exports